import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
    DynamicFormData,
    DynamicFormField,
    DynamicFormFieldChangeEvent,
} from '@app/shared/models/dynamic-form.model';
import { DynamicFormService } from '@app/shared/helpers/dynamic-form.service';

@Component({
    selector: 'app-dynamic-form',
    templateUrl: './dynamic-form.component.html',
    styleUrls: ['./dynamic-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class DynamicFormComponent implements OnInit {
    @Input() formData: DynamicFormData;
    @Output() fieldValueChange: EventEmitter<DynamicFormFieldChangeEvent> =
        new EventEmitter<DynamicFormFieldChangeEvent>();
    @Output() submitForm: EventEmitter<unknown> = new EventEmitter<unknown>();
    @Output() cancelForm: EventEmitter<undefined> = new EventEmitter<undefined>();

    form!: FormGroup;

    get isValid() {
        return this.form.valid;
    }

    constructor(public dynamicFormService: DynamicFormService) {}

    ngOnInit() {
        this.form = this.dynamicFormService.createFormGroup(this.formData);
    }

    onFieldValueChange(field: DynamicFormField, value: unknown) {
        /* eslint-disable-next-line @typescript-eslint/no-unsafe-member-access */
        if (this.form.value[field.key] !== value) {
            this.fieldValueChange.emit({
                form: this.dynamicFormService.getFormValue(),
                field,
                value,
            });
        }
    }

    onSubmit() {
        if (this.form.valid) {
            this.submitForm.emit(this.form.getRawValue());
        }
    }

    onCancel() {
        this.cancelForm.emit();
    }
}
